import React from 'react'
import '../../Work-css/Suluhu.css';
import BG from './Images/AI_bg.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass, faCartShopping } from '@fortawesome/free-solid-svg-icons';
import Cartegories from './Cartegories';
import Banners from './Banners';
import About_us from './Bar/About_us';
import Contacts from './Bar/Contacts';
import Reviews from './Bar/Reviews';
import More from './More';

import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { useState } from 'react';

function Suluhu_main() {

const [about_us_part, setAUP] = useState(false)
const [contacts, setContacts] = useState(false)
const [reviews, setReviews] = useState(false)
const [about, setAbout] = useState(false)

    const close = () =>{
        setAUP(false)
        setContacts(false)
        setReviews(false)
        setAbout(false)
    }

    const about_us = () =>{
       //setAUP(true)
    }

    const contacts_btn= () =>{
       //setContacts(true)
    }

    const rev_btn = () =>{
      // setReviews(true)
    }
  return (
    <div className='suluhu_main'>
        <div className='bar'>
            
            <p className='bar_texts'>Search</p>
            <p className='bar_texts'>Home</p>
            <p onClick={about_us} className='bar_texts'>About us</p>
            <p onClick={contacts_btn} className='bar_texts'>Contacts</p>
            <p onClick={rev_btn} className='bar_texts'>Reviews</p>
        </div>
        <div className='image_BG'>
            <img src={BG} />
           
        </div>
        <div className='BW'>
            <div>
            <p className='welcome_suluhu'>Welcome to AI Mall</p>
            {<p className='buy_suluhu'>Effortless and Elegant.</p>}
            </div> 
        </div>
        <div className='banners'>
            {/*<Banners />**/}
        </div>
        <div className='cartegories'>
            <p className='cartegory_PP'>Categories</p>
            <div className='bottomcartegory'>
                <Cartegories setAbout = {setAbout} />
            </div>
        </div>

        {about_us_part?(
        <div className='bar_DIVS'>
           <About_us />  <FontAwesomeIcon icon={faArrowLeft} className='close_PORTALS_RE' onClick={close} />    
        </div>):('')}

        {contacts?(  
        <div className='bar_DIVS'>
           <Contacts />  <FontAwesomeIcon icon={faArrowLeft} className='close_PORTALS_RE' onClick={close} />    
        </div>):('')}

        {reviews?(  
        <div className='bar_DIVS'>
           <Reviews /> <FontAwesomeIcon icon={faArrowLeft} className='close_PORTALS_RE' onClick={close} />      
        </div>):('')}
      
           {about?(  
        <div className='bar_DIVS'>
           <More /> <FontAwesomeIcon icon={faArrowLeft} className='close_PORTALS_RE' onClick={close} />      
        </div>):('')}
      
     
    </div>
  )
}

export default Suluhu_main